'use client';

import SplitHero, { SplitHeroProps } from 'components/commercetools-ui/organisms/content/split-hero';
import { TasticProps } from 'frontastic/tastics/types';

const SplitHeroTastic = ({ data }: TasticProps<SplitHeroProps>) => {
  return (
    <SplitHero
      image={data.image}
      title={data.title}
      subtitle={data.subtitle}
      ctaLabel={data.ctaLabel}
      ctaReference={data.ctaReference}
      ctaLabel2={data.ctaLabel2}
      ctaReference2={data.ctaReference2}
      imageQuality={data.imageQuality}
      isPriority={data.isPriority}
    />
  );
};

export default SplitHeroTastic;
